import dayjs from 'dayjs';

import { TWordCardSide } from 'com/WordPane/shared';

import { getKeys } from './object';

export const isCardFinished = (side: TWordCardSide): boolean =>
  side === TWordCardSide.back;

export const isWordReadyToExercise = (
  word: TWord,
  exercise: TExercise
): boolean => {
  const date = word.status[exercise]?.nextProbeAt;
  return !date || dayjs.utc(date).isBefore(dayjs.utc());
};

export const getExercisesStatuses = (word: TWord) =>
  getKeys(word.status)
    .map(exercise =>
      word.status[exercise] ? { exercise, ...word.status[exercise] } : null
    )
    .filter((v): v is TExerciseStatus & { exercise: TExercise } => !!v);
